import { render, staticRenderFns } from "./WtLayout.vue?vue&type=template&id=6fd9528c&scoped=true"
import script from "./WtLayout.vue?vue&type=script&lang=js"
export * from "./WtLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd9528c",
  null
  
)

export default component.exports